/* eslint-disable */
export const ENTRY_PORTAL_CUSTOMER_COMPANY = `Boral`;
export const ENTRY_PORTAL_CUSTOMER_NAME = `Boral Connects`;
